import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { Button,Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

import PageHeader1 from "../../components/common/PageHeader1";
import { submitMeditationPlaylistApi, getMeditationSeriesByIdApi,getMeditationCategories,getMeditationSeries } from "../../services/MeditationPlaylist";

function CreateMeditationSeries() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([""]); // For dynamic options
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [categories, setCategories] = useState([]);
  // const [meditationseries, setMeditationSeries] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [meditationGuides, setMeditationGuides] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [voiceFile, setVoiceFile] = useState(null);
  const [imageError, setImageError] = useState("");
  const [voiceError, setVoiceError] = useState("");
  const [voicePreview, setVoicePreview] = useState(null);
  const [voices, setVoices] = useState([]);

  

  // Fetch meditation details if editing
  useEffect(() => {
    if (id && categories.length > 0 && voices.length > 0) {
      (async () => {
        const res = await getMeditationSeriesByIdApi(id);
        if (res?.data) {
          const r = res.data;
          setValue("title", r.title);
          setValue("description", r.description);
          setValue("duration", r.duration);
          setValue("category", r.category); // Now categories are loaded
          setValue("languages", r.languages);
          setValue("voice", r.voice); // Now voices are loaded
          setValue("text", r.text);
          setValue("system_prompt", r.system_prompt);
          setValue("user_prompt", r.user_prompt);
          setValue("showOnHome", r.showOnHome);
          
          setImagePreview(`${r.thumbnail}`);
          setVoicePreview(`${r.audioUrl}`);
        }
      })();
    }
  }, [id, setValue, categories, voices]);

  useEffect(() => {
    // Fetch categories, languages, guides, and voices
    (async () => {
      try {
        const data = await getMeditationCategories();
        if (data.success) {
          console.log("Fetched categories:", data.meditationcategories);
          setCategories(data.meditationcategories || []);
          setLanguages(data.languages || []);
          setMeditationGuides(data.meditationGuides || []);
          setVoices(data.voices ? Object.entries(data.voices) : []);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    })();
  }, []);

  useEffect(() => {
    // Fetch categories
    (async () => {
      try {
        const response  = await getMeditationSeries();
        
          
          // setMeditationSeries(response?.data || []);
         
      
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    })();
  }, []);

  

  // Handle dynamic option field changes
  

  

  // Submit logic
  const onSubmit = async (formData) => {
    let hasError = false;
    setImageError("");
    setVoiceError("");

   
  
    
  
    if (hasError) return;
    
    // Find voice name
    const selectedVoice = voices.find((v) => v[1] === formData.voice);
    const voiceName = selectedVoice ? selectedVoice[0] : "";

    const payload = {
      ...formData,
      imageFile,
      voiceFile,
      voiceName,
    };
    if (id) payload._id = id;
    // const res = await submitMeditationPlaylistApi(payload); // make sure this uses multipart/form-data
  
    try {
      setLoading(true);
      const res = await submitMeditationPlaylistApi(payload);
      if (res) {
        if (!id) {
          reset();
          setImageFile(null);
          setImagePreview(null);
          setVoiceFile(null);
        } else {
          // navigate("/edit-page"); if needed
        }
      }
    } catch (error) {
      console.error("Error submitting playlist:", error);
      toast.error("Failed to submit playlist. Please try again.");
    } finally {
      setLoading(false); // Hide loader
    }
  };

const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  }
};

const handleVoiceChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setVoiceFile(file);
    setVoicePreview(URL.createObjectURL(file)); // create preview URL
    setVoiceError(""); // clear error
  }
};

  return (
    <div className="container">
      <PageHeader1
        pagetitle={id ? "Edit Meditation Playlist" : "Add Meditation Playlist"}
        navigation="Meditation Playlist"
        navlink="/meditation-playlist"
        current={id ? "Edit" : "Add"}
      />

      <div className="col-lg-10 mx-auto">
        <div className="card p-4 shadow-sm">
          <form onSubmit={handleSubmit(onSubmit)} className="row g-3">
            <div className="col-12 text-center">
              <h2>{id ? "Edit Playlist" : "Add New Playlist"}</h2>
            </div>

           
            

           {/* New Category Field */}
           <div className="col-md-6">
              <label className="form-label">Category</label>
              <select
                className="form-control"
                {...register("category", { required: "Category is required" })}
              >
                <option value="">Select Category</option>
                {categories.map((cat, index) => (
                  <option key={index} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
              {errors.category && (
                <p className="text-danger">{errors.category.message}</p>
              )}
            </div>
            <div className="col-md-6">
              <label className="form-label">Title</label>
              <input
                className="form-control"
                {...register("title", { required: "Title is required" })}
              />
              {errors.title && <p className="text-danger">{errors.title.message}</p>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Description</label>
              <input
                className="form-control"
                {...register("description", { required: "Description is required" })}
              />
              {errors.description && <p className="text-danger">{errors.description.message}</p>}
            </div>
            <div className="col-md-6">
              <label className="form-label">Duration(In MInutes)</label>
              <input
                className="form-control"
                {...register("duration", { required: "Duration is required" })}
              />
              {errors.duration && <p className="text-danger">{errors.duration.message}</p>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Thumbnail Image</label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                {...register("thumbnail", {
                  validate: {
                    required: (value) => {
                      // Agar existing image hai ya new image select ki hai, to validation pass
                      if (imagePreview || (value && value.length > 0)) {
                        return true;
                      }
                      return "Thumbnail image is required";
                    }
                  }
                })}
                onChange={(e) => {
                  handleImageChange(e);
                  setImageError(""); // clear error on change
                }}
              />
              {imagePreview && (
                <img
                  src={imagePreview}
                  alt="Preview"
                  className="img-thumbnail mt-2"
                  style={{ maxHeight: "200px" }}
                />
              )}
              {errors.thumbnail && <p className="text-danger">{errors.thumbnail.message}</p>}
            </div>

            <div className="col-md-6">
              <label className="form-label">Voice File</label>
              <input
                type="file"
                className="form-control"
                accept="audio/*"
                onChange={(e) => {
                  handleVoiceChange(e);
                  setVoiceError(""); // clear error on change
                }}
              />
              {voiceError && <p className="text-danger">{voiceError}</p>}
              {voicePreview && (
                <audio controls className="mt-2 w-100">
                  <source src={voicePreview} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              )}
            </div>
            {/* Language */}
            <div className="col-md-6">
              <label className="form-label">Language</label>
              <select
                className="form-control"
                {...register("languages", { required: "Language is required" })}
              >
                <option value="">Select Language</option>
                {languages.map((lang, index) => (
                  <option key={index} value={lang}>
                    {lang}
                  </option>
                ))}
              </select>
              {errors.languages && (
                <p className="text-danger">{errors.languages.message}</p>
              )}
            </div>

            <div className="col-md-6">
              <label className="form-label">Voices</label>
              <select className="form-control" {...register("voice", { required: "Voice is required" })}>
                <option value="">Select Voice</option>
                {voices.map(([name, voiceId], index) => (
                  <option key={voiceId} value={voiceId}>
                    {name}
                  </option>
                ))}
              </select>
              {errors.voice && (
                <p className="text-danger">{errors.voice.message}</p>
              )}
            </div>

            {/* Script Field */}
            <div className="col-12">
              <label className="form-label">Script</label>
              <textarea
                className="form-control"
                rows="4"
                {...register("text")}
                placeholder="Enter full meditation script..."
              ></textarea>
            </div>

            {/* System Prompt */}
            <div className="col-md-6">
              <label className="form-label">System Prompt</label>
              <textarea
                className="form-control"
                rows="3"
                {...register("system_prompt")}
                placeholder="Enter system prompt..."
              ></textarea>
            </div>

            {/* User Prompt */}
            <div className="col-md-6">
              <label className="form-label">User Prompt</label>
              <textarea
                className="form-control"
                rows="3"
                {...register("user_prompt")}
                placeholder="Enter user prompt..."
              ></textarea>
            </div>

             {/* Toggles */}
             <div className="col-md-6 d-flex align-items-center mt-4">
              <div className="form-check form-switch me-4">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="showOnHome"
                  {...register("showOnHome")}
                />
                <label className="form-check-label" htmlFor="showOnHome">
                  Show On Home
                </label>
              </div>
            </div>
            

            {/* Options Field */}
            

            {/* Submit Buttons */}
            <div className="col-12 text-center mt-4">
            <Button type="submit" className="btn btn-primary px-5 me-3" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Submitting...
                  </>
                ) : (
                  id ? "Update" : "Save"
                )}
              </Button>
              <Button
                variant="secondary"
                className="px-5"
                onClick={() => navigate("/meditation-playlist")}
              >
                Back
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CreateMeditationSeries;
